import { useEffect, useState } from 'react';
import { getCustomPlanPricing } from 'wisestep-api';

import { useWorkspaceContext, useWorkspaceSKUContext } from '../../../context';
import { useCustomPlanStore } from '../store/customPlanStore';

import PurchasePlanUI from './PurchasePlanUI';

const ValidateEnterprisePlan = () => {
  const customPlanData = useCustomPlanStore((state) => state.customPrice);
  const setCustomPrice = useCustomPlanStore((state) => state.setCustomPrice);
  const setEnableRazorPayEntBuyBtn = useCustomPlanStore(
    (state) => state.setEnableRazorPayEntBuyBtn
  );
  const workspace = useWorkspaceContext();
  const workspaceSKU = useWorkspaceSKUContext();
  const isTrialPlan = workspaceSKU?.workspacePlan?.planName === 'Trial';

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    (async () => {
      if (isTrialPlan) {
        if (workspace?.stripeCustomerId && customPlanData == null) {
          const res = await getCustomPlanPricing();
          res.data.id && setCustomPrice(res.data.coupon);
        } else if (workspace.razorpaySubscriptionId) {
          setEnableRazorPayEntBuyBtn(true);
        }
      }
      setValidated(true);
    })();
  }, [
    customPlanData,
    isTrialPlan,
    setCustomPrice,
    setEnableRazorPayEntBuyBtn,
    workspace.razorpaySubscriptionId,
    workspace.stripeCustomerId,
  ]);

  return <>{validated && <PurchasePlanUI />}</>;
};

export default ValidateEnterprisePlan;
